/**
 * Quick Delivery Estimate — internal planning-cost assumptions.
 *
 * These are intentionally simplified planning values for the lightweight
 * estimate drawer. They do not change customer-facing delivery pricing rules.
 *
 * Update here when planning rates change; do not scatter values in UI code.
 *
 * Existing portal alignment:
 * - hotelRoomPerNight ($250) and teamMembersPerRoom (2) match Non-Standard
 *   lodging auto-calc in the Delivery Fee Calculator.
 * - crewCostPerDay ($200) is a Quick Estimate simplification (not supervisor /
 *   team-member per-diem split).
 * - truck26Mpg / planningGasPricePerGallon / contingencyRate are Quick Estimate
 *   planning defaults (no prior shared fuel/contingency config existed).
 */
export const QUICK_ESTIMATE_ASSUMPTIONS = {
  /**
   * Proposal fee rates used to estimate invoice from product for delivery fee %.
   * Matches Admin Proposal defaults (product care 10%, service fee 5%).
   * Service fee base includes delivery when known; QDE uses delivery = $0 so the
   * invoice basis is pre-delivery (same state as quoting before a fee is applied).
   */
  productCareRate: 0.10,
  serviceFeeRate: 0.05,

  /** Quick Estimate Crew Cost / Day — all team members */
  crewCostPerDay: 200,

  /** Hotel room / night */
  hotelRoomPerNight: 250,

  /** Team members per hotel room (rooms = ceil(crew / this)) */
  teamMembersPerRoom: 2,

  /**
   * Planning MPG for a 26' truck.
   * Typical loaded range ~8–12 MPG; 10 is a mid-range planning default.
   */
  truck26Mpg: 10,

  /**
   * Planning gas price per gallon (USD).
   * Update periodically; not live market pricing.
   * Display rounds to whole dollars (e.g. $5.30 → "$5/gal").
   */
  planningGasPricePerGallon: 5.30,

  /** Default trucks when the user does not override */
  defaultTruckCount: 1,

  /**
   * Planning contingency applied to estimated direct cost.
   * Accounts for smaller unforeseen delivery expenses.
   */
  contingencyRate: 0.1,
};

export function getQuickEstimateAssumptions() {
  return { ...QUICK_ESTIMATE_ASSUMPTIONS };
}
